module.exports = require("./mg-MG");